module.exports = __webpack_public_path__ + "files/2ba57129854883473fc54b6d79945284.png";